<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';
import Input from 'dashboard/components-next/input/Input.vue';

// { sendMode: 'now' | 'schedule', scheduledAt: string|null }
const schedule = defineModel('schedule', { type: Object, required: true });

const { t } = useI18n();

const currentDateTime = computed(() => {
  const now = new Date();
  const localTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000);
  return localTime.toISOString().slice(0, 16);
});

const selectMode = mode => {
  schedule.value = { ...schedule.value, sendMode: mode };
};

const scheduledAt = computed({
  get: () => schedule.value.scheduledAt,
  set: value => {
    schedule.value = { ...schedule.value, scheduledAt: value };
  },
});
</script>

<template>
  <div class="flex flex-col gap-4">
    <p class="text-sm text-n-slate-11">
      {{ t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.STEP_LABEL') }}
    </p>

    <RadioCard
      id="now"
      :label="t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.SEND_NOW_LABEL')"
      :description="t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.SEND_NOW_DESCRIPTION')"
      :is-active="schedule.sendMode === 'now'"
      @select="selectMode"
    />
    <RadioCard
      id="schedule"
      :label="t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.SCHEDULE_LABEL')"
      :description="t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.SCHEDULE_DESCRIPTION')"
      :is-active="schedule.sendMode === 'schedule'"
      @select="selectMode"
    />

    <Input
      v-if="schedule.sendMode === 'schedule'"
      v-model="scheduledAt"
      type="datetime-local"
      :min="currentDateTime"
      :label="t('CAMPAIGN.WHATSAPP.WIZARD.SCHEDULE.DATE_TIME_LABEL')"
    />
  </div>
</template>
